import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import { CREATE_RECEIPT_BY_ADMIN, DELETE_INVOICE_BY_ADMIN, EDIT_INVOICE_BY_ADMIN, GET_BILLING_REPORT_BY_ADMIN, GET_INVOICES_BY_ADMIN, GET_INVOICE_EVENTS_BY_ID, ROLLBACK_INVOICE_VERSION, UPDATE_INVOICE_BY_ADMIN ,GET_RECEIPTS_INFO_BY_ADMIN} from "./actionTypes"

import { getInvoicesByAdminSuccess, getInvoicesByAdminError, updateInvoiceByAdminSuccess, updateInvoiceByAdminError, getInvoicesByAdmin, createReceiptByAdminSuccess, createReceiptByAdminError, getBillingReportByAdminSuccess, getBillingReportByAdminError, deleteInvoiceByAdminSuccess, deleteInvoiceByAdminError, editInvoiceByAdminSuccess, editInvoiceByAdminError, getInvoiceEventsByIdSuccess, getInvoiceEventsByIdError, rollbackInvoiceVersionSuccess, rollbackInvoiceVersionError, getInvoiceEventsById ,getReceiptsInfoByAdminSuccess,getReceiptsInfoByAdminError} from "./actions"

import { AppConfiguration } from "config"
import { genericPutRequest, genericGetRequest, genericPostRequest, genericDeleteRequest, fetchReport, genericGetRequest_2} from "helpers/sf_backend_helper"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildCampaignAnalysisCacheKey as buildPaginationCacheKey } from "helpers/sf_utils"

const inFlightReceiptsRequests = new Set()

function* onGetInvoicesByAdmin(action) {
  let endpoint = '/api/v1/admin_invoices'
  if (action?.payload?.use_bill_com) {
    endpoint = '/api/v1/admin_bill_com_invoices'
  }
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {}, // no query parameters
      {
        Authorization: user.token,
        "account-id": user.account_id,
      }
    )
    yield put(getInvoicesByAdminSuccess(response))
  } catch (error) {
    yield put(getInvoicesByAdminError(error))
  }
}

function* onUpdateInvoiceByAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateInvoiceByAdminSuccess(response))
    yield put(getInvoicesByAdmin(response))
  } catch (error) {
    yield put(updateInvoiceByAdminError(error))
  }
}

function* onCreateReceiptByAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(createReceiptByAdminSuccess(response))
    yield put(getInvoicesByAdmin(response))
  } catch (error) {
    yield put(createReceiptByAdminError(error))
  }
}

function* onGetBillingReportByAdmin(action) {
  try {
    let endpoint = `/api/v1/admin_invoices/get_billing_report_by_month?month=${action.payload.month}&year=${action.payload.year}&invoice_id=${action.payload.invoice_id}&brand_id=${action.payload.brand_id}`
    if (action.payload.billing_setting_invoice_change_flag_active){
      endpoint = endpoint + `&type=${action.payload.type}`
    }
    if (action?.payload?.use_bill_com) {
      endpoint = `/api/v1/admin_bill_com_invoices/${action.payload.invoice_id}/download`
    }
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      fetchReport,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {},
      {
        Authorization: user.token
      },
    );
    yield put(getBillingReportByAdminSuccess(response));
  } catch (error) {
    yield put(getBillingReportByAdminError(error));
  }
}

function* onDeleteInvoiceByAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/delete_invoice/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteInvoiceByAdminSuccess(response))
  } catch (error) {
    yield put(deleteInvoiceByAdminError(error))
  }
}

function* onEditInvoiceByAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/edit/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(editInvoiceByAdminSuccess(response))
  } catch (error) {
    yield put(editInvoiceByAdminError(error))
  }
}

function* onGetInvoiceEventsById(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/invoice_version/${action.payload.id}`,
      {
        ...action.payload
      },
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getInvoiceEventsByIdSuccess(response))
  } catch (error) {
    yield put(getInvoiceEventsByIdError(error))
  }
}

function* onGetInvoiceRollback(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/invoice_rollback/${action.payload.id}`,
      {
       body: JSON.stringify({ ...action.payload }),
      headers: {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    })
    yield put(getInvoiceEventsById({id: response.id}))
    yield put(rollbackInvoiceVersionSuccess(response))
  } catch (error) {
    yield put(rollbackInvoiceVersionError(error))
  }
}
function* onGetReciptsInfoByAdmin(action) {
  const useCache = Boolean(action.payload?.useCache)
  const queryParams = action.payload?.queryParams || {}
  const requestedPage = parseInt(queryParams.page_number, 10) || 1
  const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
  const requestKey = `${cacheKey}:${requestedPage}`

  if (useCache) {
    const cachedPage = yield select(
      (state) => state.AdminInvoices.receipts_page_cache?.[cacheKey]?.[requestedPage]
    )
    if (cachedPage) return
    if (inFlightReceiptsRequests.has(requestKey)) return
    inFlightReceiptsRequests.add(requestKey)
  }

  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_invoices/admin_receipts`,
      { ...queryParams },
      {
        Authorization: user.token,
      }
    )
    yield put(getReceiptsInfoByAdminSuccess(response, { queryParams, useCache }))
  } catch (error) {
    yield put(getReceiptsInfoByAdminError(error))
  } finally {
    if (useCache) {
      inFlightReceiptsRequests.delete(requestKey)
    }
  }
}

function* AdminInvoicesSaga() {
  yield takeEvery(GET_INVOICES_BY_ADMIN, onGetInvoicesByAdmin)
  yield takeEvery(UPDATE_INVOICE_BY_ADMIN, onUpdateInvoiceByAdmin)
  yield takeEvery(CREATE_RECEIPT_BY_ADMIN, onCreateReceiptByAdmin)
  yield takeEvery(GET_BILLING_REPORT_BY_ADMIN, onGetBillingReportByAdmin);
  yield takeEvery(DELETE_INVOICE_BY_ADMIN, onDeleteInvoiceByAdmin);
  yield takeEvery(EDIT_INVOICE_BY_ADMIN, onEditInvoiceByAdmin);
  yield takeEvery(GET_INVOICE_EVENTS_BY_ID, onGetInvoiceEventsById);
  yield takeEvery(ROLLBACK_INVOICE_VERSION, onGetInvoiceRollback);
  yield takeLatest(GET_RECEIPTS_INFO_BY_ADMIN, onGetReciptsInfoByAdmin);
}

export default AdminInvoicesSaga
